/*
 * Install kit on every skins order (required for customs declarations).
 *
 * A cart holding any Skins product carries exactly ONE Deluxe Install Kit; a cart with no
 * Skins product carries none. The skin wizard adds the kit in the same request as the skin,
 * and the guard below re-checks after every cart change, on page load and before checkout.
 * Replaces the EasyGift "Add Pro Install Kit" rule (its add ran as a separate step after
 * landing on /cart, so a quick checkout or a slow EasyGift lookup let orders out without it).
 */
(function () {
  'use strict';

  var KIT_VARIANT_ID = 46508372983982; // Deluxe Install Kit, SKU M2-INSTL-PROKIT
  var SKINS_TYPE = 'Skins';
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var cartItems = Number((document.currentScript && document.currentScript.dataset.cartItems) || 0);

  function getCart() {
    return nativeFetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Cache-Control': 'no-cache' } })
      .then(function (r) { return r.json(); });
  }

  function post(path, body) {
    return nativeFetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(path + ' ' + r.status);
      return r.json();
    });
  }

  function isKit(item) { return item.variant_id === KIT_VARIANT_ID; }

  // One kit line at quantity 1 when the cart holds a skin; no kit lines otherwise.
  function kitChange(cart) {
    var want = cart.items.some(function (i) { return i.product_type === SKINS_TYPE; }) ? 1 : 0;
    var lines = cart.items.filter(isKit);
    if (!lines.length) return want ? ['cart/add.js', { items: [{ id: KIT_VARIANT_ID, quantity: 1 }] }] : null;
    var updates = {}, changed = false;
    lines.forEach(function (line, i) {
      var qty = i === 0 ? want : 0;
      updates[line.key] = qty;
      if (line.quantity !== qty) changed = true;
    });
    return changed ? ['cart/update.js', { updates: updates }] : null;
  }

  var pending = null, rerun = false;

  function ensureKit() {
    if (pending) { rerun = true; return pending; }
    pending = getCart()
      .then(function (cart) {
        var change = kitChange(cart);
        return change && post(change[0], change[1]);
      })
      .then(function (changed) {
        if (changed) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
        }
      })
      .catch(function (err) { console.warn('install-kit:', err); })
      .then(function () {
        pending = null;
        if (rerun) { rerun = false; return ensureKit(); }
      });
    return pending;
  }

  // Re-check after any cart change made by the theme or an app (fetch and XHR).
  window.fetch = function (input, init) {
    var request = nativeFetch(input, init);
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (CART_MUTATION.test(url)) {
      request.then(function (r) { if (r.ok) ensureKit(); }, function () {});
    }
    return request;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_MUTATION.test(String(url))) {
      this.addEventListener('load', function () { if (this.status < 400) ensureKit(); });
    }
    return xhrOpen.apply(this, arguments);
  };

  // Skin wizard: add the skin and (if the cart has none) the kit in one request, then go to
  // the cart as the plain form post did. On any failure fall back to the plain form post.
  function addFromWizard(form) {
    var item = { quantity: 1, properties: {} };
    new FormData(form).forEach(function (value, name) {
      var prop = name.match(/^properties\[(.+)\]$/);
      if (prop) item.properties[prop[1]] = value; // blanks too, exactly as the form post sends them
      else if (name === 'id') item.id = Number(value);
      else if (name === 'quantity') item.quantity = Number(value) || 1;
    });
    return getCart().then(function (cart) {
      var items = [item];
      if (!cart.items.some(isKit)) items.push({ id: KIT_VARIANT_ID, quantity: 1 });
      return post('cart/add.js', { items: items });
    });
  }

  // Checkout buttons in the cart drawer and on /cart submit a cart form with name="checkout".
  function isCheckoutSubmit(event) {
    var submitter = event.submitter || document.activeElement;
    return submitter && submitter.name === 'checkout';
  }

  // The cart page re-renders its section (and the form in it) after changes, so submit the
  // checkout form that is in the page now; if there is none, go straight to checkout.
  function goToCheckout(form) {
    var button = form.isConnected ? null : document.querySelector('form [name="checkout"]');
    var live = form.isConnected ? form : button && button.form;
    if (!live) { window.location.href = root + 'checkout'; return; }
    var flag = document.createElement('input');
    flag.type = 'hidden';
    flag.name = 'checkout';
    live.appendChild(flag);
    HTMLFormElement.prototype.submit.call(live);
  }

  // Wizard: capture phase, so this runs before the form's own submit listeners. Shopify's
  // pixel counts a form add unless the submit is cancelled, and counts the fetch add below
  // too, so cancelling first keeps it at one AddToCart for the skin.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    // getAttribute: the wizard form has an input named "id", which shadows form.id.
    if (!(form instanceof HTMLFormElement) || (form.getAttribute('id') || '').indexOf('product-form-wizard-') !== 0) return;
    event.preventDefault();
    addFromWizard(form).then(
      function () { window.location.href = (window.routes && window.routes.cartUrl) || root + 'cart'; },
      function (err) { console.warn('install-kit:', err); HTMLFormElement.prototype.submit.call(form); }
    );
  }, true);

  // Checkout: bubble phase, so a script that blocks checkout (defaultPrevented) still wins.
  // Never hold checkout up for more than a few seconds if a cart request hangs.
  document.addEventListener('submit', function (event) {
    if (event.defaultPrevented || !isCheckoutSubmit(event)) return;
    event.preventDefault();
    var form = event.target;
    var timeout = new Promise(function (resolve) { setTimeout(resolve, 4000); });
    Promise.race([ensureKit(), timeout]).then(function () { goToCheckout(form); });
  });

  if (cartItems > 0) ensureKit();
  window.addEventListener('pageshow', function (event) { if (event.persisted) ensureKit(); });
})();
